







































import {
  computed,
  defineComponent,
  ref,
  useAsync,
  useContext,
  useRoute,
} from '@nuxtjs/composition-api';
import { UCIcon } from '@shared/ui';
import { BaseButton, BaseCallToAction, BaseInput, BaseLoader } from '@shared/ui';
import { useNewsletterSignup } from '@unified-commerce/gpc-vue-storefront-shopify-admin';
import { getStoryBlokVersion, useContent } from '@unified-commerce/gpc-vue-storefront-storyblok';

import Container from '~/components/Container.vue';
import ErrorIcon from '~/static/icons/close.svg?inline';

export default defineComponent({
  name: 'EmailSubscription',
  components: {
    BaseButton,
    BaseCallToAction,
    BaseInput,
    BaseLoader,
    ErrorIcon,
    UCIcon,
    Container,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    heading_text: {
      type: String,
      default: 'Sign up for emails to get the latest offers',
    },
    // eslint-disable-next-line vue/prop-name-casing
    email_placeholder_text: {
      type: String,
      default: 'Enter email address',
    },
    // eslint-disable-next-line vue/prop-name-casing
    submit_button_text: {
      type: String,
      default: 'Subscribe',
    },
  },
  setup() {
    const { $config } = useContext();
    const route = useRoute();
    const { search, content = {} } = useContent('emailSubscriptionContent');
    const { signupToNewsletter, loading, result, error } =
      useNewsletterSignup('email-newsletter-signup');
    const email = ref('');

    useAsync(() => {
      search({
        url: 'content/email-subscription',
        version: getStoryBlokVersion($config.ENV, route.value),
      });
    }, route.value.path);

    const emailSubscription = computed(() => (Array.isArray(content.value) ? null : content.value));

    const onSubmitEmailSubscription = async (e: Event) => {
      e.preventDefault();
      await signupToNewsletter({ email: email.value });
    };

    const successHeadingText = 'Subscribed!';
    const successSubHeadingText =
      "You'll get the latest updates on AMX promotions, events, and all the latest motorcycle gear!";

    return {
      email,
      emailSubscription,
      signupToNewsletter,
      loading,
      result,
      error,
      onSubmitEmailSubscription,
      successHeadingText,
      successSubHeadingText,
    };
  },
});
